import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../common/PageHeader';
import '../../styles/Auth.css';

const NotFound: React.FC = () => (
  <>
    <PageHeader
      title="404 - Page Not Found"
      subtitle="Sorry, the page you are looking for does not exist."
    />
    <div className="auth-container" style={{ textAlign: 'center', marginTop: '2rem' }}>
      <p>The page you requested could not be found.</p>
      <Link to="/" className="primary-button">Go to Home</Link>
    </div>
  </>
);

export default NotFound;
